import { render } from "./Profile.vue?vue&type=template&id=e52bc5aa&scoped=true&bindings={}"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=e52bc5aa&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-e52bc5aa"

export default script